<template>
  <div>
    <!-- 菜单切换tabs -->
    <activity-tabs></activity-tabs>
    <!-- 菜单 -->
    <el-col
      v-if="topButtonList != null && topButtonList.length > 0"
      :span="24"
      class="toolbar"
      style="padding-bottom: 0px"
    >
      <el-form :inline="true" @submit.native.prevent :model="filters">
        <div class="divFlex">
          <div class="flexlLeft">
            <el-form-item>
              <el-input
                placeholder="公司/姓名"
                v-model="filters.SearchKey"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-input
                placeholder="手机"
                v-model="filters.PhoneNumber"
                clearable
                maxlength="11"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-select v-model="filters.EAR_From" placeholder="报名方式">
                <el-option
                  label="--报名方式--"
                  :value="-1"
                  key="-1"
                ></el-option>
                <el-option
                  v-for="(item, index) in registrationFromList"
                  :label="item.Name"
                  :value="item.Value"
                  :key="index"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select v-model="filters.EAR_Source" placeholder="报名来源">
                <el-option label="--报名来源--" value="" key="-1"
                  >--报名来源--</el-option
                >
                <el-option
                  v-for="(item, index) in registrationSourceList"
                  :label="item"
                  :value="item"
                  :key="index"
                ></el-option>
                <!-- <el-option label="客户发展部" :value="1" key="1"></el-option>
                <el-option label="股份" :value="2" key="2"></el-option> -->
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select v-model="filters.EAR_AgreeReg" placeholder="报名状态">
                <el-option
                  label="--报名状态--"
                  :value="-1"
                  key="-1"
                ></el-option>
                <el-option label="待审核" :value="0" key="0"></el-option>
                <el-option label="审核通过" :value="1" key="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select v-model="filters.SendState" placeholder="发送状态">
                <el-option
                  label="--发送状态--"
                  :value="-1"
                  key="-1"
                ></el-option>
                <el-option label="未发送" :value="0" key="0"></el-option>
                <el-option label="已发送" :value="1" key="1"></el-option>
              </el-select>
            </el-form-item>
          </div>

          <div class="flexRight">
            <el-form-item v-for="item in topButtonList" v-bind:key="item.id">
              <el-button
                v-prevent-re-click
                :type="
                  item.Func &&
                  (item.Func.toLowerCase().indexOf('handledel') != -1 ||
                    item.Func.toLowerCase().indexOf('stop') != -1)
                    ? 'danger'
                    : 'primary'
                "
                v-if="!item.IsHide"
                @click="callFunc(item)"
                >{{ item.name }}</el-button
              >
            </el-form-item>
          </div>
        </div>
      </el-form>
    </el-col>

    <div>
      <!-- 数据列表 -->
      <el-table
        :data="tabData"
        border=""
        v-loading="listLoading"
        @selection-change="handleSelectionChange"
        ref="table"
        style="width: 100%"
        class="custom-tbl"
      >
        <el-table-column type="selection" width="40"></el-table-column>
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <!-- <el-table-column
          prop="EAR_OrderNumber"
          label="票号"
          width=""
        ></el-table-column> -->
        <el-table-column
          prop="EAR_Company"
          label="公司名称"
          width=""
          show-overflow-tooltip
        ></el-table-column>
      <el-table-column
        prop="OwnerUserName"
        label="归属人"
        width=""
      ></el-table-column>
        <el-table-column
          prop="EAR_Name"
          label="姓名"
          width="80"
        ></el-table-column>
  
        <el-table-column
          prop="EAR_Tel"
          label="手机号"
          width=""
        ></el-table-column>
        <el-table-column
          prop="EAR_Position"
          label="参会人职位"
          width=""
        ></el-table-column>
        <el-table-column
          prop="ParticipantType"
          label="参会类型"
          width="80"
        ></el-table-column>
        <el-table-column
          prop="TicketsName"
          label="门票类型"
          width="80"
        ></el-table-column>
        <el-table-column
          prop="EAR_AddTime"
          label="报名时间"
          width=""
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="EAR_From"
          label="报名方式"
          width="90"
        ></el-table-column>
   
        <el-table-column prop="EAR_AgreeReg" label="报名状态" width="80">
          <template slot-scope="scope">
            <el-switch
              @change="enabledChange(scope)"
              v-model="scope.row.EAR_AgreeReg"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-value="审核通过"
              inactive-value="待审核"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="" label="发送状态" width="80">
          <template slot-scope="scope">
            <div class="badgeClass">
              <el-button
                :type="scope.row.SMSCount > 0 ? 'success' : 'danger'"
                icon="el-icon-mobile-phone"
                disabled
                circle
                size="small"
              ></el-button>
              <el-button
                :type="scope.row.EmailCount > 0 ? 'success' : 'danger'"
                icon="el-icon-message"
                disabled
                circle
                size="small"
              ></el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="EAR_signTime"
          label="签到时间"
          width=""
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column prop="IsDoneInvoiceMemberType" label="核销" width="60">
          <template slot-scope="scope">
            <el-tag
              :type="
                scope.row.IsDoneInvoiceMemberType === false ? 'info' : 'success'
              "
              >{{
                scope.row.IsDoneInvoiceMemberType === false ? '否' : '是'
              }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="70"
          v-if="tableButtonList.length > 0"
        >
          <template slot-scope="scope">
            <span v-for="item in tableButtonList" :key="item.id">
              <el-button
                type="text"
                v-bind:key="item.id"
                v-prevent-re-click
                :disabled="
                  (item.name == '核销' && scope.row.IsDoneInvoiceMemberType) ||
                  (item.name == '签到' && scope.row.EAR_signTime)
                "
                v-if="!item.IsHide"
                @click="callFunc(item, scope.row)"
                >{{ item.name }}</el-button
              >
            </span>
          </template>
        </el-table-column>
      </el-table>
      <!--工具条-->
      <el-pagination
        layout="total, sizes, prev, pager, next"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="filters.PageIndex"
        :page-size="filters.PageSize"
        :page-sizes="[20, 40, 60, 80]"
        :total="filters.total"
        style="float: right"
      ></el-pagination>
    </div>

    <!-- 批量导入 -->
    <el-dialog
      title="批量导入"
      class="dialog-import"
      :visible.sync="importDialogVisible"
      :before-close="importHandleClose"
      width="50%"
    >
      <div class="importTop">
        <div><span>1</span>上传文件</div>
        <div><span>2</span>导入数据</div>
      </div>
      <div class="importList">
        <div class="bgIcon"></div>
        <div class="importList_R">
          <p class="font6">填写导入数据信息</p>
          <p class="font9">
            请按照数据模板的格式准备导入数据，模板中的表头名称不可更改，表头行不能删除
          </p>
          <p>
            <a href="#" @click="downloadTemp" class="fontG">下载模板</a>
          </p>
        </div>
      </div>
      <div class="importList">
        <div class="bgIcon bgIcon1"></div>
        <div class="importList_R">
          <p class="font6">上传</p>
          <p class="font9">
            文件后缀名必须为xls 或xlsx
            （即Excel格式），文件大小不得大于10M，最多支持导入3000条数据
          </p>
          <el-upload
            class="upload-demo"
            ref="upload"
            action=""
            :http-request="uploadAtteedee"
            :on-progress="importProgress"
            :before-upload="importBefore"
            :show-file-list="false"
            :file-list="fileList"
            :on-change="fileChange"
            accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          >
            <p>
              <a href="#" class="fontG">{{ importText }}</a>
            </p>
          </el-upload>
        </div>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
        @click="importDialogVisible = false"
      >
        <el-button @click="importDialogVisible = false" class="hoverBtn1"
          >取 消</el-button
        >
      </span>
    </el-dialog>
    <!-- 数据导入中 -->
    <el-dialog
      title="批量导入中"
      class="dialog-import"
      :visible.sync="dialogVisibleLoading"
      :before-close="importHandleClose"
      width="50%"
    >
      <div class="SuccessBox">
        <i class="el-icon-loading"></i>
        <h4 class="font6">数据导入中，请耐心等待....</h4>
      </div>
    </el-dialog>
    <!-- 导入完成 -->
    <el-dialog
      title="批量导入"
      class="dialog-import"
      :visible.sync="dialogVisibleSuccess"
      :before-close="importSuccessHandleClose"
      width="50%"
    >
      <div class="SuccessBox">
        <i class="el-icon-success"></i>
        <h4 class="font6">批量导入完成</h4>
        <p class="font9">{{ improtMsg }}</p>
      </div>
    </el-dialog>
    <!-- 导入失败 -->
    <el-dialog
      title="批量导入"
      class="dialog-import"
      :visible.sync="dialogVisibleFailure"
      :before-close="importFailureHandleClose"
      width="50%"
    >
      <div class="importTop">
        <div><span>1</span>上传文件</div>
        <div><span>2</span>导入数据</div>
      </div>
      <div class="importList">
        <div class="bgIcon3"><i class="el-icon-warning"></i></div>
        <div class="importList_R">
          <p class="font6">
            正常数量条数: <span class="fontG">{{ successCount }}条</span>
          </p>
          <p class="font6">
            异常数量条数: <span class="fontR">{{ errorCount }}条</span>
          </p>
        </div>
      </div>
      <div class="abnormalBox">
        <p class="title">异常提示：</p>
        <p v-for="item in errorMsg" :key="item">{{ item }}</p>
        <p>请检查无误后重新上传！</p>
      </div>

      <span
        slot="footer"
        class="dialog-footer"
        @click="dialogVisibleFailure = false"
      >
        <el-button @click="importAgain" type="primary" class="fontF"
          >重新上传</el-button
        >
      </span>
    </el-dialog>

    <!-- 新增报名 -->
    <el-dialog
      :title="dialogAddTitle"
      :visible.sync="dialogAdd"
      :close-on-click-modal="false"
      :before-close="addHandleClose"
      width="50%"
    >
      <el-form
        :model="rulesAddForm"
        :rules="rulesAdd"
        ref="rulesAddForm"
        label-width="100px"
        class="demo-ruleForm addFormBox"
      >
        <el-form-item prop="EAR_Company" label="公司名称">
          <el-select
            v-model="rulesAddForm.EAR_Company"
            placeholder="请输入公司名称"
            :loading="loadingCompanyName"
            filterable
            default-first-option
            clearable
            remote
            reserve-keyword
            :remote-method="remoteMethod"
          >
            <el-option
              v-for="item in CompanyList"
              :key="item.companyCode"
              :label="item.companyName"
              :value="item.companyName"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="EAR_Name" label="姓名">
          <el-input
            v-model="rulesAddForm.EAR_Name"
            placeholder="参会者姓名"
            clearable
            :disabled="isEdit"
          ></el-input>
        </el-form-item>
        <el-form-item prop="EAR_Position" label="职位">
          <el-input
            v-model="rulesAddForm.EAR_Position"
            placeholder="参会者职位"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item prop="EAR_Tel" label="手机号">
          <el-input
            v-model="rulesAddForm.EAR_Tel"
            placeholder="参会者手机号"
            clearable
            maxlength="11"
            :disabled="isEdit"
          ></el-input>
        </el-form-item>
        <el-form-item prop="EAR_Email" label="邮箱">
          <el-input
            v-model="rulesAddForm.EAR_Email"
            placeholder="参会者邮箱"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item prop="ParticipantType" label="参会类型">
          <el-select
            v-model="rulesAddForm.ParticipantType"
            placeholder="参会类型"
          >
            <el-option
              v-for="item in participantTypes"
              :label="item.Name"
              :value="item.Name"
              :key="item.Id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="EAR_Meal" label="是否含餐">
          <el-select
            v-model="rulesAddForm.EAR_Meal"
            placeholder="请选择是否含餐"
          >
            <el-option label="不含餐" value="不含餐"></el-option>
            <el-option label="含餐" value="含餐"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitAddForm('rulesAddForm')"
            >提交</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>

    <div class="divStatis" v-html="statisticText"></div>
  </div>
</template>

<script>
const token = window.localStorage.getItem('Token')
import ActivityTabs from '@/components/ActivityTabs.vue'
import { getButtonList } from '../../promissionRouter'
import {
  getActivityRegList,
  getActivityRegistrationSign,
  enabledActivityRegistrationAgreeReg,
  getActivityRegistrationSourceList,
  getActivityRegistrationFromList,
  updMemberAvailableTimes,
  importActivityRegistrationFile,
  getParticipantTypeList,
  getCustomerCompanyList,
  getSlyFuzzySearchList,
  ActivityRegisterAddOrUpd,
  getActivityRegInfoList,
  SendActivityRegistrationNotice,
  GetSendActivityRegistrationNoticeCount,
  ActivityRegistrationStatistic,
} from '../../api/api'
import store from '@/store'
export default {
  name: 'regList',
  data() {
    return {
      topButtonList: [],
      tableButtonList: [],
      filters: {
        ActivityId: store.getters.getCurActivityId,
        EAR_From: -1, // 报名方式
        EAR_Source: '', // 来源
        EAR_AgreeReg: -1, // 报名状态
        SearchKey: '', // 公司、姓名、票号
        PhoneNumber: '', // 手机
        SendState: -1, // 发送状态
        PageIndex: 1, //第几页
        PageSize: 20, // 每页多少条
        total: 0, // 总记录
        pageCount: 1,
      },
      tabData: [], // 列表数据
      listLoading: false,
      registrationSourceList: [], // 报名来源
      registrationFromList: [], //报名方式
      importDialogVisible: false, // 批量导入
      exportLink: `${process.env.VUE_APP_BASE_API}/api/ActivityRegistration/template/export`,
      headers: { Authorization: 'Bearer ' + token },
      importText: '上传文件',
      fileList: [],
      improtMsg: '', // 导入成功或失败的文字
      successCount: 0,
      errorCount: 0,
      errorMsg: {},
      dialogVisibleLoading: false,
      dialogVisibleSuccess: false,
      dialogVisibleFailure: false,
      multipleSelection: [], // 选中的数据（多选）
      selectRegID: [], // 选中后数据的ID，用于核销、签到
      dialogAdd: false, // 新增报名
      dialogAddTitle: '',
      rulesAddForm: {
        ActivityIDStr: store.getters.getCurActivityId,
        EAR_Company: '',
        EAR_Name: '',
        EAR_Position: '',
        EAR_Tel: '',
        EAR_Email: '',
        ParticipantType: '',
        EAR_Meal: '不含餐',
      },
      rulesAdd: {
        EAR_Company: [
          { required: true, message: '请输入公司名称', trigger: 'blur' },
        ],
        EAR_Name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        EAR_Position: [
          { required: true, message: '请输入职位', trigger: 'blur' },
        ],
        EAR_Tel: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          {
            pattern: /^1\d{10}$/,
            message: '请输入正确的手机号',
            trigger: 'blur',
          },
        ],
        EAR_Email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' },
        ],
        ParticipantType: [
          { required: true, message: '请选择参会类别', trigger: 'blur' },
        ],
      },
      isEdit: false,
      participantTypes: [], // 参会类型
      loadingCompanyName: false, // 公司名称搜索加载效果
      CompanyList: [], // 公司列表
      statistic: {
        RegCount: null,
        ValidRegCount: null,
        SignCount: null,
        SignRate: '',
      },
      statisticText: '',
    }
  },
  components: {
    ActivityTabs,
  },
  methods: {
    // 按钮点击事件传值
    callFunc(item, row) {
      this.currentRow = row
      this[item.Func].apply(this, item)
    },

    // 多选数据
    handleSelectionChange(val) {
      this.multipleSelection = val
      this.selectRegID = this.multipleSelection.map(
        (item) => item.ActivityRegistrationID
      )
    },

    // 翻页事件
    handleSizeChange(pageSize) {
      this.filters.PageSize = pageSize
      this.handleQuery()
    },
    // 翻页事件
    handleCurrentChange(currentPage) {
      this.filters.PageIndex = currentPage
      this.handleQuery()
    },

    // 新增报名
    handleAdd() {
      this.dialogAdd = true
      this.dialogAddTitle = '新增报名'
      this.isEdit = false
      // 获取参会类型
      getParticipantTypeList().then((res) => {
        this.participantTypes = res.data.response.slice(0, 2)
      })
    },
    // 新增报名 —— 按钮
    submitAddForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          ActivityRegisterAddOrUpd(this.rulesAddForm).then((res) => {
            if (res.data.success) {
              this.handleQuery()
              this.$message({
                message: res.data.msg,
                type: 'success',
              })
              this.dialogAdd = false
              this.$refs.rulesAddForm.resetFields()
              this.CompanyList = []
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error',
              })
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 编辑 报名信息
    handleUpdate() {
      this.dialogAdd = true
      this.dialogAddTitle = '编辑报名'
      this.isEdit = true
      // 获取参会类型
      getParticipantTypeList().then((res) => {
        this.participantTypes = res.data.response.slice(0, 2)
      })
      getActivityRegInfoList(this.currentRow.ActivityRegistrationID).then(
        (res) => {
          if (res.data.success) {
            this.rulesAddForm = res.data.response
          }
        }
      )
    },
    // 新增报名——弹窗关闭
    addHandleClose() {
      this.dialogAdd = false
      this.$refs.rulesAddForm.resetFields()
    },
    // 适用的公司
    remoteMethod(query) {
      if (query !== '') {
        this.loadingCompanyName = true
        let debItem = null
        if (debItem) {
          clearTimeout(debItem)
        }
        debItem = setTimeout(() => {
          // getCustomerCompanyList(query).then((res) => {
          //   this.CompanyList = res.data.response
          // })

          getSlyFuzzySearchList(query).then((res) => {
            // console.log(res)
            if (res.data.success) {
              this.CompanyList = res.data.response.data.data
              this.loadingCompanyName = false
            }
          })
        }, 2000)
      }
    },

    // 查询按钮——显示数据
    handleQuery() {
      if (!this.filters.ActivityId) {
        this.$message({
          message: '非正常访问',
          type: 'error',
        })
        setTimeout(() => {
          this.$router.push(`/DetpActivity/Activity`)
        }, 2000)
        return
      }
      this.listLoading = true
      getActivityRegList(this.filters).then((res) => {
        if (res.data.success) {
          this.filters.total = res.data.response.dataCount
          this.filters.pageCount = res.data.response.pageCount
          this.tabData = res.data.response.data
          this.listLoading = false
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
          })
        }
      })
      // 签到数据
      ActivityRegistrationStatistic(this.filters.ActivityId).then((res) => {
        if (res.data.success) {
          this.statistic = res.data.response
          if (res.data.response.SignCount !== 0) {
            this.statisticText =
              '报名数：' +
              res.data.response.RegCount +
              '；有效报名数：' +
              res.data.response.ValidRegCount +
              '；签到数：' +
              res.data.response.SignCount +
              '；签到率：' +
              res.data.response.SignRate
          }
        }
      })
    },

    // 签到
    handleSign() {
      this.$confirm('确定要签到吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          let itemInfo = {
            ActivityID: this.filters.ActivityId,
            ActivityRegistrationIDs: this.selectRegID,
          }
          getActivityRegistrationSign(itemInfo).then((res) => {
            if (res.data.success) {
              this.$message({
                type: 'success',
                message: '签到成功!',
              })
              this.handleQuery()
            } else {
              this.$message({
                message: '签到失败！',
                type: 'error',
              })
            }
          })
          this.handleQuery()
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消成功',
          })
        })
    },
    // 报名状态——同意 / 待审核
    enabledChange(scope) {
      console.log(scope)
      enabledActivityRegistrationAgreeReg({
        regId: scope.row.ActivityRegistrationID,
        agree: scope.row.EAR_AgreeReg === '审核通过' ? 1 : 0,
      }).then((res) => {
        if (res.data.success) {
          this.$message({
            message: res.data.msg,
            type: 'success',
          })
          this.handleQuery()
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
          })
        }
      })
    },

    // 报名来源
    ActivityRegistrationSourceList() {
      getActivityRegistrationSourceList(this.filters.ActivityId).then((res) => {
        if (res.data.success) {
          this.registrationSourceList = res.data.response
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
          })
        }
      })
    },
    // 报名方式
    ActivityRegistrationFromList() {
      getActivityRegistrationFromList().then((res) => {
        if (res.data.success) {
          this.registrationFromList = res.data.response
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
          })
        }
      })
    },

    // 核销按钮
    handleVerification() {
      this.$confirm('确定要核销吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          var user = JSON.parse(window.localStorage.user);
          let itemInfo = {
            ActivityID: this.filters.ActivityId,
            ActivityRegistrationIDs: this.selectRegID,
            Type: 1,
            UserName: user.uLoginName,
          }
          updMemberAvailableTimes(itemInfo).then((res) => {
            if (res.data.success) {
              this.$message({
                message: '核销成功！',
                type: 'success',
              })
              this.handleQuery()
            } else {
              this.$message({
                message: res.data.msg,
                type: 'warning',
              })
            }
          })
          
           console.log(user.uLoginName)
          this.handleQuery()
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消成功',
          })
        })
    },

    // 取消核销按钮
    handleCancelVerification() {
      this.$confirm('确定要核销吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          var user1 = JSON.parse(window.localStorage.user);
          let itemInfo = {
            ActivityID: this.filters.ActivityId,
            ActivityRegistrationIDs: this.selectRegID,
            Type: 2,
            UserName: user1.uLoginName,
          }
          updMemberAvailableTimes(itemInfo).then((res) => {
            if (res.data.success) {
              this.$message({
                message: '取消核销成功！',
                type: 'success',
              })
              this.handleQuery()
            } else {
              this.$message({
                message: '取消核销失败！',
                type: 'warning',
              })
            }
          })
          this.handleQuery()
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消成功',
          })
        })
    },

    // 导出
    handleExport() {
      const token = window.localStorage.getItem('Token')
      const url = `${process.env.VUE_APP_BASE_API}/api/ActivityRegistration/export`
      var xhr = new XMLHttpRequest()
      xhr.open('post', url, true)
      // 2.2 设置请求头,作用是设置参数的编码格式，以便后台能够正确的接收所传递的参数
      xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8')
      xhr.responseType = 'blob' // 返回类型blob
      xhr.setRequestHeader('Authorization', 'Bearer ' + token) // 携带token校验

      xhr.onload = function () {
        if (this.status === 200) {
          var blob = this.response
          var reader = new FileReader()
          reader.readAsDataURL(blob) // 转换为base64
          reader.onload = function (e) {
            var a = document.createElement('a') // 创建一个a标签用于下载
            a.download = '参会人员' + new Date().getTime() + '.xls' //文件名
            a.href = e.target.result
            a.click()
            $(a).remove()
          }
        }
      }
      xhr.send(JSON.stringify(this.filters))
    },

    // 导入报名按钮
    handleImport() {
      this.importDialogVisible = true
    },

    importHandleClose() {
      this.importDialogVisible = false
    },

    // 下载导入模板
    downloadTemp() {
      window.open(this.exportLink)
    },

    // -----文件上传时的钩子
    importProgress(event, file, fileList) {
      this.dialogVisibleLoading = true
    },
    // -----上传文件之前的钩子，参数为上传的文件，若返回 false 或者返回 Promise 且被 reject，则停止上传。
    importBefore(file) {
      if (
        file.type !== 'application/vnd.ms-excel' &&
        file.type !==
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      ) {
        this.$message.error('请上传xls或xlsx格式的Excel')
        return false
      }
      if (file.size > 1024 * 1024 * 10) {
        this.$message.error('上传的文件不得大于10M')
        return false
      }
    },
    // -----文件状态改变时的钩子，添加文件、上传成功和上传失败时都会被调用
    fileChange(file) {
      this.$refs.upload.clearFiles() //清除文件对象
      this.fileList = [{ name: file.name, url: file.url }] // 重新手动赋值filstList， 免得自定义上传成功了, 而fileList并没有动态改变， 这样每次都是上传一个对象
    },
    // -----覆盖默认的上传行为，可以自定义上传的实现
    uploadAtteedee(param) {
      const form = new FormData()
      form.append('file', param.file)
      importActivityRegistrationFile({
        activityId: this.filters.ActivityId,
        form,
      })
        .then((response) => {
          param.onSuccess() // 上传成功的图片会显示绿色的对勾
          this.dialogVisibleLoading = false
          this.successCount = response.data.response.SuccessCount
          this.errorCount = response.data.response.ErrorCount
          if (response.data.success) {
            if (!response.data.response.Result) {
              this.dialogVisibleFailure = true
              this.errorMsg = response.data.response.ErrorMsg.split(';')
              return
            } else {
              this.dialogVisibleSuccess = true
              this.improtMsg = '导入成功'
              this.handleQuery()
            }
          } else {
            this.errorMsg = response.data.response.ErrorMsg.split(';')
            this.dialogVisibleFailure = true
          }
        })
        .catch((response) => {
          param.onError()
          this.dialogVisibleLoading = false
          this.$message.error('导入异常，请联系开发人员')
        })
    },
    // 导入失败，重新上传
    importAgain() {
      this.importDialogVisible = true
      this.importDisabled = false
      this.importText = '上传文件'
    },
    // 关闭导入成功的弹窗
    importSuccessHandleClose() {
      this.dialogVisibleSuccess = false
      this.importDialogVisible = false
    },
    // 导入失败的弹窗
    importFailureHandleClose() {
      this.dialogVisibleFailure = false
    },

    // 发送门票 邮件 通知
    handleNotice() {
      const noticeParam = {
        Type: 2,
        SendWay: 1,
        ActivityID: this.filters.ActivityId,
        ActivityRegistrationIds: this.selectRegID,
      }
      GetSendActivityRegistrationNoticeCount(noticeParam).then((res) => {
        console.log('aa res', res)
        if (res.data.success) {
          this.$confirm(
            `确定要发送${res.data.response}条门票邮件吗？`,
            '提示',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
            }
          )
            .then(() => {
              // 调用发送方法（type: 0.报名成功 1.审核通过 2.电子门票 SendWays: 发送方式 1.邮件 2.短信）
              this.sendEmailAndSms(noticeParam, '门票邮件')
              this.handleQuery()
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '已取消成功',
              })
            })
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
          })
        }
      })
    },

    // 发送门票 短信 通知
    handleSmsNotice() {
      const noticeParam = {
        Type: 2,
        SendWay: 2,
        ActivityID: this.filters.ActivityId,
        ActivityRegistrationIds: this.selectRegID,
      }

      GetSendActivityRegistrationNoticeCount(noticeParam).then((res) => {
        console.log('aa res', res)
        if (res.data.success) {
          this.$confirm(
            `确定要发送${res.data.response}条门票短信吗？`,
            '提示',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
            }
          )
            .then(() => {
              // 调用发送方法（type: 0.报名成功 1.审核通过 2.电子门票 SendWays: 发送方式 1.邮件 2.短信）
              this.sendEmailAndSms(noticeParam, '门票短信')
              this.handleQuery()
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '已取消成功',
              })
            })
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
          })
        }
      })
    },

    // 发送邮件、短信 共用方法（type: 0.报名成功 1.审核通过 2.电子门票 SendWays: 发送方式 1.邮件 2.短信）
    sendEmailAndSms(noticeParam, info) {
      SendActivityRegistrationNotice(noticeParam).then((res) => {
        console.log('aa res', res)
        if (res.data.success) {
          this.$message({
            message: info + res.data.msg,
            type: 'success',
          })
        } else {
          this.$message({
            message: info + res.data.msg,
            type: 'error',
          })
        }
      })
    },
  },
  mounted() {
    this.handleQuery()
    this.ActivityRegistrationSourceList() // 报名来源
    this.ActivityRegistrationFromList()
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : []
    let buttonList = getButtonList(this.$route.path, routers)
    this.topButtonList = buttonList.filter((item) => {
      return item.ButtonType === 0
    })
    this.tableButtonList = buttonList.filter((item) => {
      return item.ButtonType === 1
    })
    // console.log(this.tableButtonList)
  },
}
</script>

<style scoped>
/* .custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
} */
.divFlex {
  display: block;
  flex: 1;
}
.divFlex .flexRight {
  width: 100%;
  margin-bottom: 15px;
}
.divFlex .flexlLeft {
  width: 100%;
}
.toolbar .el-form-item {
  margin-bottom: 10px;
}
.el-input {
  width: 217px;
}
.el-select {
  width: 150px;
}
.flexRight .el-button {
  width: 100px;
}
.flexRight .el-button--medium {
  padding: 10px 5px;
}
.dialog-import .importTop {
  display: flex;
  font-weight: bold;
  color: #666;
}

.dialog-import .importTop > div {
  margin-right: 30px;
}

.dialog-import .importTop > div span {
  display: inline-block;
  width: 40px;
  height: 40px;
  font-size: 30px;
  line-height: 40px;
  color: #fff;
  background: #30a53f;
  margin-right: 10px;
  text-align: center;
}

.dialog-import .importTop > div:last-child span {
  background: #cccccc;
}

.dialog-import .importList {
  display: flex;
  border: 1px solid #e9e9e9;
  align-items: center;
  height: 110px;
  margin-top: 20px;
}

.dialog-import .importList .bgIcon {
  background: url(../../assets/icon_download.png) no-repeat center #f5f5f5;
  height: 100%;
  width: 100px;
  line-height: 110px;
  background-size: 60px;
  margin-right: 15px;
  text-align: center;
}

.dialog-import .importList .bgIcon1 {
  background: url(../../assets/icon_upload.png) no-repeat center #f5f5f5;
  background-size: 60px;
}

.dialog-import .importList .bgIcon3 {
  background: #f5f5f5;
  font-size: 46px;
  color: #cccccc;
  width: 100px;
  margin-right: 15px;
  text-align: center;
  height: 100%;
  line-height: 110px;
}

.dialog-import .importList .importList_R {
  font-size: 14px;
  flex: 1;
}

.dialog-import .importList .importList_R > p {
  padding: 5px 0;
  margin: 0 0;
}
.upload-demo p {
  padding: 0 0;
  margin: 0 0;
}
.fontG {
  color: #30a53f;
}
.SuccessBox {
  text-align: center;
  margin: 30px 0;
}

.SuccessBox i {
  color: #30a53f;
  font-size: 100px;
}

.SuccessBox h4 {
  margin: 30px;
  font-size: 20px;
}
.abnormalBox {
  line-height: 24px;
}
.SuccessBox1 {
  margin: 50px auto;
  width: 20%;
  padding: 0 20px;
  line-height: 50px;
  height: 50px;
  text-align: center;
  background: #30a53f;
}

.SuccessBox1 i {
  font-size: 30px;
  color: #fff;
  top: 5px;
  margin-right: 10px;
}

.SuccessBox1 a {
  display: block;
  width: 100%;
  height: 100%;
  color: #fff;
}
.el-icon-warning {
  font-size: 60px;
}
.addFormBox .el-input,
.addFormBox .el-select {
  width: 100%;
}
.el-button--small.is-circle {
  padding: 5px;
}

.badgeClass .badgeItem {
  margin-top: 15px;
}
.badgeClass div + div {
  margin-left: 20px;
}
.divStatis {
  position: fixed;
  top: 70px;
  right: 90px;
}
</style>
